define(
({
  "load_error": "Erro a carregar",
  "description": "Um pedido não foi concluído corretamente. Certifique-se de que a sua encomenda foi guardada e, em seguida, atualize esta página."
})
);
